/** Year span for Statewide Analysis and related publication GHG inventory views. */
export const PUBLICATION_GHG_CHART_YEAR_MIN = 2005;

/**
 * Last inventory year shown anywhere on the Analysis page (and matching CSV exports).
 * 2024–25 stay out until those inventory years are populated.
 */
export const PUBLICATION_GHG_CHART_YEAR_MAX = 2023 as const;

/** Stacked geography time series chart — same ceiling as {@link PUBLICATION_GHG_CHART_YEAR_MAX}. */
export const PUBLICATION_GHG_STACKED_TIMESERIES_YEAR_MAX = PUBLICATION_GHG_CHART_YEAR_MAX;

/** Spatial maps and rankings — same ceiling as {@link PUBLICATION_GHG_CHART_YEAR_MAX}. */
export const PUBLICATION_GHG_SPATIAL_YEAR_MAX = PUBLICATION_GHG_CHART_YEAR_MAX;

/** Statewide vs. CARB Figure 4 comparison — same ceiling as {@link PUBLICATION_GHG_CHART_YEAR_MAX}. */
export const PUBLICATION_CARB_COMPARE_YEAR_MAX = PUBLICATION_GHG_CHART_YEAR_MAX;

/**
 * Side-by-side per-capita choropleth maps use quintile breakpoints from this inventory year for every
 * selected year (colors compare historical per capita to the {year} distribution).
 */
export const PUBLICATION_MAP_QUINTILE_REFERENCE_YEAR = PUBLICATION_GHG_CHART_YEAR_MAX;
